var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * API service for API client (Keycloak service account) operations.
 */
import { getHeaders } from "./apiUtils";
var API_CLIENTS_ENDPOINT = "czna-users/api-clients";
var DEFAULT_LIMIT = 50;
export var fetchApiClients = function (ky_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([ky_1], args_1, true), void 0, function (ky, params) {
        var _a, offset, _b, limit, searchParams;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            _a = params.offset, offset = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? DEFAULT_LIMIT : _b;
            searchParams = new URLSearchParams();
            searchParams.set("offset", offset.toString());
            searchParams.set("limit", limit.toString());
            return [2 /*return*/, ky
                    .get("".concat(API_CLIENTS_ENDPOINT, "?").concat(searchParams), {
                    headers: getHeaders(),
                })
                    .json()];
        });
    });
};
export var fetchApiClientById = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .get("".concat(API_CLIENTS_ENDPOINT, "/").concat(id), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var createApiClient = function (ky, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .post(API_CLIENTS_ENDPOINT, {
                json: data,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var updateApiClient = function (ky, id, data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .put("".concat(API_CLIENTS_ENDPOINT, "/").concat(id), {
                json: data,
                headers: getHeaders(),
            })
                .json()];
    });
}); };
export var deleteApiClient = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, ky.delete("".concat(API_CLIENTS_ENDPOINT, "/").concat(id), {
                    headers: getHeaders(),
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
export var regenerateApiClientSecret = function (ky, id) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, ky
                .post("".concat(API_CLIENTS_ENDPOINT, "/").concat(id, "/regenerate-secret"), {
                headers: getHeaders(),
            })
                .json()];
    });
}); };
